import React from "react";
import { CustomButton } from "@shared/components";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";

/**
 * Replace Confirmation Modal.
 * Shown when a user tries to upload for a month that already has a submission.
 *
 * Props:
 *   isOpen     {boolean}
 *   onClose    {fn}
 *   onConfirm  {fn}
 *   loading    {boolean}
 *   month      {string}  — e.g. "April"
 *   year       {number}
 */
const ReplaceConfirmModal = ({ isOpen, onClose, onConfirm, loading, month, year }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>Replace Existing OAAP?</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body2" color="text.primary">
            An OAAP has already been submitted for{" "}
            <strong>{month} {year}</strong>.
          </Typography>
          <Typography variant="body2">
            Uploading a new file will <strong>replace the existing submission</strong>.
          </Typography>
          <Typography variant="body2">Do you want to continue?</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <CustomButton variant="outline" onClick={onClose} disabled={loading} size="sm">
          Cancel
        </CustomButton>
        <CustomButton onClick={onConfirm} disabled={loading} loading={loading} size="sm">
          {loading ? "Replacing\u2026" : "Yes, Replace"}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ReplaceConfirmModal;
